import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  Divider,
  Button,
  Card,
  Collapse,
  Form,
  Input,
  Row,
  Col,
  Space,
  Badge,
  Popconfirm,
  Empty,
  Select,
} from "antd";
import * as Icon from "react-feather";
import { useDispatch } from "react-redux";
import appLoaderAction from "../../redux/action/app-loader-action";
import notifyUtitls from "../../utils/notify-utils";
import CustomTable from "../../components/table/custom-table";
import AddFooterLinkDialog from "./AddEditFooterLinkDialog";
import fileUtils from "../../utils/file-utils";
import { groupType, PREVIEW_TYPE } from "../../constants/app-constants";
import footerLinkService from "../../services/footer-link-service";
import serviceLinkService from "../../services/service-link-service";
import EditableTagGroup from "../../components/input/editable-tag-group";
import arrayMove from "array-move";
import SortableList from "../../components/sort/sortable-list";
import previewService from "../../services/preview-Service";
import userService from "../../services/user-service";

const { Panel } = Collapse;
const { Option } = Select;

function callback(key) {
  console.log(key);
}

const FooterLink = () => {
  const dispatch = useDispatch();
  const [isShowAddFileDialog, setIsShowAddFileDialog] = useState(false);
  const [editData, setEditData] = useState(null);
  const [condition, setCondition] = useState({ title: null, status: null });
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    rowPerPage: 10,
    rowCount: 0,
  });
  const [keywordList, setKeywordList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [displayList, setDisplayList] = useState([]);
  const [userList, setUserList] = useState([]);

  const columns = [
    {
      title: "ชื่อลิงค์ส่วนท้าย",
      dataIndex: "title",
      key: "name",
      render: (record) => {
        return (
          <a>{record?.titleTH != null ? record?.titleTH : record?.titleEN}</a>
        );
      },
    },
    {
      title: "ลิงค์",
      dataIndex: "url",
      key: "url",
      render: (data) => {
        return (
          <a
            href="#"
            onClick={() => {
              window.open(
                data,
                "winname",
                "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no"
              );
            }}
          >
            ลิงค์
          </a>
        );
      },
    },
    {
      title: "จำนวนผู้เข้าชม",
      dataIndex: "totalView",
      key: "totalView",
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Badge
          color={text ? "#4A9A0F" : "#CBCACA"}
          className="text-nowrap"
          text={text ? "Online" : "Offline"}
        />
      ),
    },
    {
      title: "ผู้บันทึก",
      key: "createBy",
      dataIndex: "createBy",
      render: (createBy) => {
        let check = userList.find((user) => createBy === user.userId);
        if (check) {
          return `${check.profile?.firstName} ${check.profile?.lastName}`;
        } else {
          return `undefined`;
        }
      },
    },
    {
      title: "ผู้แก้ไข",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (updateBy) => {
        let check = userList.find((user) => updateBy === user.userId);
        if (check) {
          return `${check.profile?.firstName} ${check.profile?.lastName}`;
        } else {
          return `undefined`;
        }
      },
    },

    {
      title: "ดำเนินการ",
      key: "action",
      fixed: "right",
      width: 100,
      render: (record) => (
        <Space size="middle">
          <a onClick={() => onClickEdit(record)} className="pe-3 border-end">
            <Icon.Edit size={18} />
          </a>

          <Popconfirm
            title="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onConfirmDelete(record.footerLinkId)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <a>
              <Icon.Trash size={18} />
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function initData() {
      const response = await userService.search();
      setUserList(response.list);
    }
    initData();
    doSearch(1);
    doSearchDisplay();
  }, []);

  useEffect(() => {
    if (editData) {
      onEdit(editData);
    }
  }, [editData]);

  const onAdd = () => {
    setEditData(null);
    setIsShowAddFileDialog(true);
  };

  const onCancel = () => {
    setIsShowAddFileDialog(false);
    setEditData(null);
  };

  const onSaveComplete = () => {
    setEditData(null);
    setIsShowAddFileDialog(false);
    doSearch(1);
  };

  const onEdit = (data) => {
    setEditData(data);
    setIsShowAddFileDialog(true);
  };

  const onChangeCondition = (event) => {
    const { name, value } = event.target;
    setCondition({ ...condition, [name]: value });
  };

  const onChangePage = (currentPage) => {
    doSearch(currentPage);
  };

  const doSearch = async (currentPage) => {
    try {
      const newPaginate = {
        ...pagination,
        currentPage: currentPage ? currentPage : pagination.currentPage,
      };
      dispatch(appLoaderAction.enable());

      const newCondition = {
        title: condition.title,
        keywordList: keywordList,
        status: condition.status,
        createBy: condition.createBy,
      };
      const result = await footerLinkService.search(newCondition, newPaginate);
      setDataList(result.list);
      setPagination(result.pagination ? result.pagination : newPaginate);
      setSelectedRowKeys([]);
      setSelectedRows([]);

      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      //dispatch(notifyUtitls.error(err));
      notifyUtitls.error(err)
    }
  };

  const onClearSearch = () => {
    setCondition({ title: null, status: null });
    setKeywordList([]);
  };

  const onClickEdit = (record) => {
    try {
      dispatch(appLoaderAction.enable());
      setEditData(record);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onConfirmDelete = (id) => {
    onDelete(id);
  };

  const onDelete = async (id) => {
    try {
      dispatch(appLoaderAction.enable());
      await footerLinkService.remove({ deleteId: id });
      dispatch(appLoaderAction.disale());
      notifyUtitls.success("สำเร็จ", "ลบข้อมูลสำเร็จ");
      doSearch(1);
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const rowSelection = () => {
    return {
      onChange: (selectedRowKeys, selectedRows) => {
        setSelectedRows(selectedRows);
        setSelectedRowKeys(selectedRowKeys);
      },
      selectedRowKeys,
    };
  };

  const doSearchDisplay = async () => {
    try {
      dispatch(appLoaderAction.enable());

      const result = await footerLinkService.getDisplay();

      setDisplayList(result.list);
      dispatch(appLoaderAction.disale());
    } catch (err) {
      dispatch(appLoaderAction.disale());
      //dispatch(notifyUtitls.error(err));
      notifyUtitls.error(err)
    }
  };

  const onAddToDisplay = () => {
    if (selectedRows.length === 0) {
      notifyUtitls.warning(
        "เพิ่มการแสดงลิงค์ส่วนท้าย",
        "กรุณาเลือกลิงค์ส่วนท้ายอย่างน้อย 1 รายการ"
      );
    } else if (displayList.length + selectedRows.length > 8) {
      notifyUtitls.warning(
        "เพิ่มการแสดงลิงค์ส่วนท้าย",
        "เพิ่มการแสดงลิงค์ส่วนท้ายเกิน 8 ลิงค์"
      );
    } else {
      const compare = selectedRows.filter((item) => {
        return (
          displayList.findIndex(
            (serviceLink) => serviceLink.footerLinkId === item.footerLinkId
          ) < 0
        );
      });
      const newDisplayList = [...displayList, ...compare];

      //console.log('newDisplayList', newDisplayList);

      setDisplayList(newDisplayList);
      setSelectedRows([]);
      setSelectedRowKeys([]);
    }
  };

  const onSaveDisplay = async () => {
    try {
      dispatch(appLoaderAction.enable());

      await footerLinkService.saveDisplay({ listBean: displayList });

      dispatch(appLoaderAction.disale());
      notifyUtitls.success("สำเร็จ", "บันทึกการแสดงผลลิงค์ส่วนท้ายสำเร็จ");
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const onClearDisplay = () => {
    doSearchDisplay();
  };

  const onRemoveDisplay = (serviceLinkId) => {
    const newList = [...displayList];
    const index = displayList.findIndex(
      (item) => item.serviceLinkId === serviceLinkId
    );
    newList.splice(index, 1);
    setDisplayList(newList);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setDisplayList(arrayMove(displayList, oldIndex, newIndex));
  };

  const onPreview = async () => {
    try {
      dispatch(appLoaderAction.enable());

      // dispatch(serviceLinkPreviewAction.addServiceLinkPreview(displayList));

      const result = await previewService.savePreview({
        preview: { content: PREVIEW_TYPE.footerLink, listBean: displayList },
      });

      setTimeout(() => {
        dispatch(appLoaderAction.disale());
        window.open(
          `${process.env.REACT_APP_PREVIEW_ENDPOINT}/?token=${result.token}`,
          "winname",
          "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no"
        );
      }, 500);
    } catch (err) {
      dispatch(appLoaderAction.disale());
      notifyUtitls.error(err);
    }
  };

  const renderOptionUser = () => {
    return userList?.map((item) => {
      if (item?.profile) {
        const profile = item.profile;
        return (
          <Select.Option value={item.userId} key={item.userId}>
            {`${profile.firstName} ${profile.lastName}`}
          </Select.Option>
        );
      } else {
        return null;
      }
    });
  };

  const onChangeSelect = (name) => {
    return (value) => {
      setCondition({ ...condition, [name]: value });
    };
  };

  return (
    <div>
      <h2 className="color-primary-title">ลิงค์ส่วนท้าย</h2>
      <Breadcrumb>
        <Breadcrumb.Item>การจัดการเนื้อหา</Breadcrumb.Item>
        <Breadcrumb.Item>ลิงค์ส่วนท้าย</Breadcrumb.Item>
      </Breadcrumb>
      <Divider className="mt-2 mb-4" />
      <div className="d-flex justify-content-between">
        <Button type="primary" onClick={() => onAdd()}>
          <Icon.Plus className="me-1" size={18} /> เพิ่มลิงค์ส่วนท้าย
        </Button>
        <div>
          <Button className="btn-gray" onClick={() => onClearDisplay()}>
            ล้างค่าการแสดงผลลิงค์ส่วนท้าย
          </Button>
          <Button
            type="primary"
            className="mx-2"
            onClick={() => onSaveDisplay()}
          >
            <Icon.Save className="me-1" size={18} />{" "}
            บันทึกการแสดงผลลิงค์ส่วนท้าย
          </Button>
          <Button className="mx-2 btn-line" onClick={() => onPreview()}>
            <Icon.Eye className="me-1" size={18} /> ดูตัวอย่างเว็บไซต์
          </Button>
        </div>
      </div>
      <Card className="mt-4" bordered={false}>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel header="ตัวกรอง" key="1">
            <div>
              <Form layout="vertical">
                <Row gutter={20}>
                  <Col span={7}>
                    <Form.Item label="ชื่อลิงค์ส่วนท้าย" className="mb-0">
                      <Input
                        name="title"
                        value={condition.title}
                        onChange={onChangeCondition}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="คีย์เวิร์ด" className="mb-0">
                      <EditableTagGroup
                        customWidth="100%"
                        name="keywordList"
                        onChange={setKeywordList}
                        tags={keywordList}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="ผู้บันทึก" className="mb-0">
                      <Select
                        showSearch
                        placeholder="Search to Select"
                        optionFilterProp="children"
                        allowClear
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                        value={condition.createBy}
                        onChange={onChangeSelect("createBy")}
                      >
                        {renderOptionUser()}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item label="สถานะ" className="mb-0">
                      <Select
                        name="status"
                        value={condition.status}
                        onChange={onChangeSelect("status")}
                      >
                        <Option value={null}>All</Option>
                        <Option value={true}>Online</Option>
                        <Option value={false}>Offline</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={20}>
                  <Col className="mt-4">
                    <Button
                      type="primary"
                      className="w-100"
                      onClick={() => doSearch(1)}
                    >
                      <Icon.Search className="me-1" size={18} /> ค้นหา
                    </Button>
                  </Col>
                  <Col className="mt-4">
                    <Button
                      className="btn-gray"
                      onClick={() => onClearSearch()}
                    >
                      ล้างค่า
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Panel>
        </Collapse>
        <Collapse className="mb-4" defaultActiveKey={["1"]} onChange={callback}>
          <Panel
            header="การแสดงผลลิงค์ส่วนท้าย (ได้สูงสุด 8 ลิงค์ส่วนท้าย)"
            key="1"
          >

            {displayList.length > 0 ? (
              <SortableList
                axis={"xy"}
                items={displayList}
                onSortEnd={onSortEnd}
                onRemove={onRemoveDisplay}
                groupValue={groupType.FOOTER_LINK}
              />
            ) : (
              <Empty />
            )}

          </Panel>
        </Collapse>

        <div>
          <Button
            type="primary"
            className="mx-2"
            onClick={() => onAddToDisplay()}
          >
            <Icon.Plus className="me-1" size={18} /> เพิ่มการแสดงผลลิงค์ส่วนท้าย
          </Button>
        </div>

        <CustomTable
          rowSelection={{
            type: "checkbox",
            ...rowSelection(),
          }}
          rowKey="footerLinkId"
          tableName="footerLinkTable"
          columns={columns}
          data={dataList}
          scroll={{ x: true }}
          isPagination={true}
          onChangePage={onChangePage}
          currentPage={pagination.currentPage}
          pageSize={pagination.rowPerPage}
          totalRecord={pagination.rowCount}
        />
      </Card>
      <AddFooterLinkDialog
        isShow={isShowAddFileDialog}
        editData={editData}
        onCancel={onCancel}
        onSaveComplete={onSaveComplete}
      ></AddFooterLinkDialog>
    </div>
  );
};

export default FooterLink;
